import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  teamMembersContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(0.5),
    alignSelf: 'stretch',
    backgroundColor: theme.palette.bgV2.main,
    borderRadius: theme.spacing(0.5),
    padding: theme.spacing(1, 2),
  },
  teamMembersHeading: {
    color: theme.palette.labraText.tertiary,
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '24px',
    letterSpacing: '0.15px',
  },
  infoIcon: {
    fontSize: '16px',
    color: theme.palette.labraIcon.main,
  },
  infoIconContainer: {
    textAlign: 'center',
    height: theme.spacing(2),
    width: theme.spacing(2),
  },
  teamMembersHeadingContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(1),
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  orderList: {
    padding: theme.spacing(0, 2),
  },
}))
